






































import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator';
import DraggableEvent from './DraggableEvent.vue'
//@ts-ignore
import { shiftDataStore } from '@/store/theoryApiStore/shiftDataModule.ts';

@Component({
  components: {
    DraggableEvent
  }
})
export default class MoreShiftsPopup extends Vue {
  @Prop({type: Number, required: true})
  public year!: number;
  @Prop({type: Number, required: true})
  public month!: number;
  @Prop({type: Number, required: true})
  public day!: number;
  @Prop({type: Function, required: true})
  public clickEvent!: (eventId: string) => void;
  @Prop({type: Function, required: true})
  public closePopup!: () => void;
  @Prop({type: Number, required: true})
  public width!: number;
  @Ref()
  public card!: any;
  get dayOfWeek() {
    return [ "日", "月", "火", "水", "木", "金", "土" ][new Date(this.year, this.month-1, this.day).getDay()]
  }
  private eventSummaryFormat(event: any): string {
    return `${event.start.getHours()}:${`00${event.start.getMinutes()}`.slice(-2)} ${event.name}`
  }
  get eventsInDate() {
    return (year: number, month: number, day: number) => {
      return shiftDataStore.eventsForCalendar.filter((event: any) => {
        return event.start.getFullYear() === year && event.start.getMonth() === month-1 && event.start.getDate() === day;
      }).sort((left: any, right: any) => {
        if(left.start.getTime() > right.start.getTime()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }
}
